import styled from '@emotion/styled';

export const ModalOverlay = styled.div<{ isOpen: boolean }>`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: #fff;
	display: flex;
	flex-direction: column;
	opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
	visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
	transition: all 0.3s ease;
	z-index: 99;
`;

export const ModalContent = styled.ul`
	display: flex;
	width: 100%;
	flex-direction: column;
	padding: 0.8rem 0rem;
`;

export const MainMenu = styled.div`
	color: #212529;
	text-align: center;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-style: normal;
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	text-transform: uppercase;
	text-decoration: none;
	display: flex;
	flex-direction: column;
	align-items: start;
	width: 100%;
	padding: 1.6rem 2rem;
	cursor: pointer;
	&:hover {
		background-color: #f8f9fa;
	}
`;
export const ModalHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	padding: 2rem;
	width: 100%;
	background-color: ${(props) => props.theme.colors.primary400};
`;

export const TitleBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
	color: #fff;
	.title {
		font-size: 1.8rem;
		font-weight: 400;
		line-height: 100%;
		letter-spacing: -0.6px;
		strong {
			font-size: 2rem;
			font-weight: 600;
			line-height: 130%;
			letter-spacing: -0.6px;
		}
	}
`;
export const LogoutButton = styled.button`
	display: flex;
	align-items: center;
	background-color: transparent;
	border: none;
	color: #fff;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	height: 3.2rem;
	cursor: pointer;
`;

export const CloseButtonBox = styled.div`
	display: flex;
	justify-content: flex-end;
	cursor: pointer;
`;
